const WORK_FILTERS = {
    ALL: "All",
    MOBILE_WEB: "Mobile/Web",
    DATA_SCIENCE: "Data Science",
    OTHERS: "Others",
}

export default WORK_FILTERS;